import React, { useState } from 'react';

/**
 * Dark SEO panel that matches the site background.
 *
 * `preview` is always visible, everything inside `children` stays in the DOM but
 * is collapsed until the visitor presses "See More" (so crawlers still read it).
 */
const SeoPanel = ({ id, preview, children }) => {
  const [expanded, setExpanded] = useState(false);
  const moreId = `${id}-more`;

  return (
    <section className="seo-panel" aria-labelledby={`${id}-title`}>
      {preview}

      <div id={moreId} className={`seo-more${expanded ? ' is-open' : ''}`}>
        {children}
      </div>

      <button
        type="button"
        className="seo-toggle"
        aria-expanded={expanded}
        aria-controls={moreId}
        onClick={() => setExpanded((open) => !open)}
      >
        {expanded ? 'See Less' : 'See More'}
      </button>
    </section>
  );
};

export default SeoPanel;
